import { format } from 'date-fns';
import React, { useEffect } from 'react';
import { useFieldArray } from 'react-hook-form';
import { useSelector } from 'react-redux';
import ModerationVacancyItem from './ModerationVacancyItem';
import VacancyItem from './VacancyItem';
import InfiniteScroll from 'react-infinite-scroll-component';

export default function VacancyList({ onLoadMore, update = () => {}, fields, form, filter }) {
  return (
    <div>
      <div className="flex w-full flex-col">
        <div className="" style={{ overflowX: 'auto' }}>
          <div className="p-2 min-w-full inline-block align-middle">
            <div className="border rounded-lg ">
              {' '}
              <InfiniteScroll dataLength={fields.length} next={onLoadMore} hasMore={true}>
                <table className="min-w-full divide-y divide-gray-200 mb-20">
                  <tbody className="divide-y divide-gray-200 ">
                    {' '}
                    {fields.map((list, index) =>
                      filter?.value == 'moderation' ? (
                        <ModerationVacancyItem
                          key={list.id}
                          {...list}
                          handleCheckChange={(val) => {
                            update(index, val);
                          }}
                        />
                      ) : (
                        <VacancyItem
                          key={list.id}
                          id={list.id}
                          handleCheckChange={(val) => {
                            update(index, val);
                          }}
                          {...list}
                        />
                      ),
                    )}
                  </tbody>
                </table>
              </InfiniteScroll>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
